export {default} from './Home';


// WEBPACK FOOTER //
// ./src/containers/Home/index.js